import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from "react-i18next";
import RolesTab from './RolesTab';
import UsersTab from './UsersTab';
import ActivityLogsTab from './ActivityLogsTab';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`roles-tabpanel-${index}`}
      aria-labelledby={`roles-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `roles-tab-${index}`,
    'aria-controls': `roles-tabpanel-${index}`,
  };
}

export default function RolesManagement() {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="roles management tabs">
          <Tab style={{ marginRight: "20px" }} label={t('roles_tab')} {...a11yProps(0)} />
          <Tab style={{ marginRight: "20px" }} label={t('users_tab')} {...a11yProps(1)} />
          <Tab style={{ marginRight: "20px" }} label={t('activity_logs')} {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <RolesTab />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <UsersTab />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ActivityLogsTab />
      </TabPanel>
    </Box>
  );
} 